import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

export function creatingConf(
    state: any = {
        values: {},
        isValid: false
    },
    action: Action
) {
    switch (action.type) {
        case GamesActionTypes.UPDATE_CREATING_CONF:
            const values =
                state && action.payload
                    ? { ...state.values, ...action.payload.values }
                    : action.payload
                    ? action.payload.values
                    : null;

            const isValid =
                state && action.payload ? action.payload.isValid : false;

            values.subsidiary =  typeof values.subsidiary === "object" ? values.subsidiary.id : values.subsidiary

            return {
                values,
                isValid: isValid
            };

        case GamesActionTypes.CREATE_CONF_SUCCESS:
        case GamesActionTypes.EDIT_CONF_SUCCESS:
        case GamesActionTypes.CREATE_CONF_RESET:
            return {
                values: {},
                isValid: false
            };

        default:
            return state;
    }
}
